export enum PrescriptionDrugFrequencyEnum {
  "EveryMonth" = '30',
  "EveryTwoMonths" = '60',
  "EveryThreeMonths" = '90',
  "EverySixMonths" = '180',
  "EveryTwelveMonths" = '360'
}
